import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=e6ce830e&scoped=true"
import script from "./EmptyList.vue?vue&type=script&lang=js"
export * from "./EmptyList.vue?vue&type=script&lang=js"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=e6ce830e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ce830e",
  null
  
)

export default component.exports